import React from 'react'

function CidiSymbol() {
  return (
    <>
    <span>&#8373;</span>
    </>
  )
}

export default CidiSymbol